module.exports = "<form ng-class=\"{disabled: disabled}\"> <textarea class=\"js-st-instance\">{{data}}</textarea> </form> ";